import React, { useContext } from "react";
import LoadingPage from "../../components/LoadingPage";
import { OrganisationContext } from "../../context/OrganisationContext";
import { useDynamicsSettings } from "../../hooks/useDynamicsSettings";
import { AvailableIntegrations } from "@attelas/shared";
import CreateOrganisation from "../Organisation/CreateOrganisation";
import DeactivatedOrganisation from "../Organisation/DeactivatedOrganisation";
import { ConnectionTip } from "../Connections/ConnectionTip";

const Authorization: React.FC<{ children }> = ({ children }) => {
  const { organisation, isLoading } = useContext(OrganisationContext);
  const appIntegrations = organisation?.integrations?.appIntegrations ?? [];
  const isConnectingDynamicsOnly =
    appIntegrations.length === 1 && appIntegrations[0].name === AvailableIntegrations.Dynamics;
  const { settings, isLoading: isDynamicsSettingsLoading } = useDynamicsSettings(isConnectingDynamicsOnly);
  const selectedDynamicsCompanies = settings?.companies ?? [];
  // If we are connecting Dynamics only, we need to check if there are any companies selected
  const isConnected = isConnectingDynamicsOnly ? selectedDynamicsCompanies.length > 0 : appIntegrations.length > 0;

  if (isLoading || isDynamicsSettingsLoading) {
    return <LoadingPage />;
  }

  if (!organisation) {
    return <CreateOrganisation />;
  }

  if (!organisation.isActive) {
    return <DeactivatedOrganisation />;
  }

  if (!isConnected) {
    return <ConnectionTip />;
  }

  return <>{children}</>;
};

export default Authorization;
